import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Button, Modal } from "react-bootstrap";
import { ExclamationTriangleFill } from "react-bootstrap-icons";

import { UserSelect } from "./user-select";

export const RegistrationModal = ({ handleOk, handleClose }) => {
  const [user, setUser] = useState(null);

  return (
    <Modal show={true} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex">
          <ExclamationTriangleFill className="align-self-center me-2 text-info" />
          <span>
            <FormattedMessage id="page.apps.label.registration.title" />
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <FormattedMessage id="page.apps.label.registration.description" />
        </div>
        <div>
          <UserSelect
            userId={user?.id}
            handleUserSelect={(user) => {
              setUser(user);
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          <FormattedMessage id="page.apps.button.cancel" />
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            handleOk(user);
          }}
          disabled={user === null}
        >
          <FormattedMessage id="page.apps.button.create" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

RegistrationModal.propTypes = {
  handleOk: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};
